import { makeAutoObservable } from "mobx"
import { AxiosResponse } from "axios/index"

import { notify } from "@src/app/components/notify"
import { paths } from "@src/app/paths"
import { APIResponse, authApi, catchErrors } from "@src/shared/api"
import { router } from ".."

export class RecoveryConfirmStore {
  isLoading = false

  recoverConfirm = async (identity: {
    code: string
    confirm_password: string
    email: string
    password: string
  }) => {
    this.isLoading = true

    return authApi
      .recoveryEnd(identity)
      .then(() => router.navigate(paths.default))
      .catch(catchErrors)
      .finally(() => {
        this.isLoading = false
      })
  }

  constructor() {
    makeAutoObservable(this)
  }
}
